import { DiscardTrigger, needDiscardData } from 'helpers/discardTriggerHelpers'
import { Staleable } from 'interfaces/global'
import { Reducer } from 'interfaces'
import { Action } from 'redux'


export function createStaleableReducer<T> (dataReducer: Reducer<T>, triggers: DiscardTrigger[]) {
  const initialState: Staleable<T> = {
    data: dataReducer(undefined, { type: '@@INIT' } as Action),
    isStale: false,
  }

  const staleableReducer: Reducer<Staleable<T>> = (state, action) => {
    const prevState = state || initialState

    if (needDiscardData(triggers)(action)) {
      return prevState
        ? {
          data: prevState.data,
          isStale: true,
        }
        : prevState
    }

    const nextData: T | null = dataReducer(prevState.data, action)
    let isStale = prevState.isStale

    if (!isStale && nextData === prevState.data) {
      return prevState
    }

    if (nextData !== prevState.data) {
      isStale = false
    }

    return {
      data: nextData,
      isStale,
    }
  }

  return staleableReducer
}

type UnpackedStaleable<T> =
  T extends Staleable<infer U>
    ? U
    : never;

export function getStaleableData<TStale extends Staleable<any>> (state: TStale | null | undefined): UnpackedStaleable<TStale> | null {
  return state && state.data
    ? state.data
    : null
}

export function isDataUpToDate (state: Staleable<any> | null | undefined): boolean {
  return !!state && !state.isStale
}

export function createStaleableData<T> (data: T, isStale = false): Staleable<T> {
  return {
    data,
    isStale,
  }
}
